import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import api from '../../services/api';
import './Dashboard.css';

const AdminDashboard = () => {
    const { t, i18n } = useTranslation();
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchStats();
    }, []);

    const fetchStats = async () => {
        try {
            const response = await api.get('/admin/dashboard/stats');
            if (response.data.success) {
                setStats(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching stats:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="loading-container">
                <div className="loading-spinner"></div>
                <p>{t('common.loading')}</p>
            </div>
        );
    }

    const isAr = i18n.language === 'ar';



    return (
        <div className="dashboard fade-in">
            <div className="page-header">
                <h1>{t('admin.dashboard.title')}</h1>
            </div>

            <div className="stats-grid">
                <div className="stats-card">
                    <div className="content">
                        <h3>{stats?.teachers || 0}</h3>
                        <p>{t('admin.dashboard.totalTeachers')}</p>
                    </div>
                    <div className="icon-box gold">
                        <span className="material-icons">school</span>
                    </div>
                </div>

                <div className="stats-card">
                    <div className="content">
                        <h3>{stats?.students || 0}</h3>
                        <p>{t('admin.dashboard.totalStudents')}</p>
                    </div>
                    <div className="icon-box green">
                        <span className="material-icons">people</span>
                    </div>
                </div>

                <div className="stats-card">
                    <div className="content">
                        <h3>{stats?.courses || 0}</h3>
                        <p>{t('admin.dashboard.totalCourses')}</p>
                    </div>
                    <div className="icon-box blue">
                        <span className="material-icons">book</span>
                    </div>
                </div>
            </div>


        </div>
    );
};

export default AdminDashboard;
